import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { ListItem as CoreListItem } from '@vds-core/lists';
import { calculateRem } from '@uie/javascript-style-helpers';
import { BodyConfig, MicroConfig } from '@vds-core/typography';
import { calculateSpacing } from '@vds-core/theme';

var ListItem = function ListItem(props) {
  function _calculatePadding() {
    return calculateRem(6);
  }

  function _calculateBulletSpacing() {
    return calculateSpacing('2X');
  }

  return /*#__PURE__*/React.createElement(CoreListItem, _extends({}, props, {
    calculateBulletSpacing: _calculateBulletSpacing,
    bodyConfig: BodyConfig,
    microConfig: MicroConfig,
    calculatePadding: _calculatePadding,
    nested: false,
    inverted: false
  }));
};

export default ListItem;